import React from "react";

/**
 * Fonts are declared statically in public/index.html (and apps-index.html) so they
 * begin downloading before React mounts; only tokens and keyframes live here.
 *
 * Single source of truth for the DataPulse Web design system: typography, the
 * colour tokens, and the shared keyframes. Every page on the website-building
 * side of the business renders this so the subpages match the landing page.
 *
 * Palette discipline: one cool family (navy -> cyan) for all surfaces, rails and
 * structure; one warm signal (#FF6A3D) rationed strictly to actions and live state.
 */
export function WebStyles() {
  return (
    <>
      <style>{`
        html, body { background-color: #060B14 !important; }

        .dp-display { font-family: 'Bricolage Grotesque', 'Instrument Sans', ui-sans-serif, system-ui, sans-serif; font-optical-sizing: auto; }
        .dp-body    { font-family: 'Instrument Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif; }
        .dp-mono    { font-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace; font-feature-settings: 'tnum' 1; }

        /* Visible keyboard focus, without a ring on mouse clicks */
        .dp-focus:focus-visible { outline: 2px solid #FF6A3D; outline-offset: 2px; border-radius: 6px; }

        .dp-noscrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .dp-noscrollbar::-webkit-scrollbar { display: none; }

        /* Faint blueprint grid, masked to a soft pool */
        .dp-grid {
          background-image:
            linear-gradient(to right, rgba(56,189,248,0.05) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(56,189,248,0.05) 1px, transparent 1px);
          background-size: 76px 76px;
          -webkit-mask-image: radial-gradient(72% 60% at 50% 22%, #000 0%, transparent 100%);
          mask-image: radial-gradient(72% 60% at 50% 22%, #000 0%, transparent 100%);
        }

        @keyframes dp-drift {
          0%, 100% { transform: translate3d(0,0,0); opacity: 0.18; }
          25%      { transform: translate3d(8px,-16px,0); opacity: 0.5; }
          50%      { transform: translate3d(-6px,-30px,0); opacity: 0.28; }
          75%      { transform: translate3d(-10px,-16px,0); opacity: 0.42; }
        }
        .dp-particle { position: absolute; border-radius: 9999px; pointer-events: none; will-change: transform, opacity; }

        @keyframes dp-marquee {
          from { transform: translate3d(0,0,0); }
          to   { transform: translate3d(-50%,0,0); }
        }
        .dp-marquee-track { animation: dp-marquee 42s linear infinite; will-change: transform; }
        .dp-marquee:hover .dp-marquee-track { animation-play-state: paused; }

        @media (prefers-reduced-motion: reduce) {
          .dp-particle { animation: none !important; opacity: 0.22 !important; }
          .dp-marquee-track { animation: none !important; }
          html { scroll-behavior: auto; }
        }
        @media (prefers-reduced-motion: no-preference) {
          html { scroll-behavior: smooth; }
        }
      `}</style>
    </>
  );
}

export default WebStyles;
